<template>
  <div class="login-container">
    <div class="login-box" :style="{ opacity: isLoaded ? 1 : 0 }">
      <h2>数字化管理系统</h2>
      <div class="input-group">
        <el-input v-model="username" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
      </div>
      <div class="input-group">
        <el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-lock" type="password"></el-input>
      </div>
      <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      isLoaded: false
    }
  },
  mounted() {
    // 确保样式加载完成后再显示内容
    this.$nextTick(() => {
      setTimeout(() => {
        this.isLoaded = true
      }, 100)
    })
  },
  methods: {
    handleLogin() {
      if (!this.username || !this.password) {
        this.$message.error('请输入账号和密码')
        return
      }
      
      this.loading = true
      
      // 模拟登录验证
      setTimeout(() => {
        if (this.username === 'admin' && this.password === 'cua88888888') {
      const expireTime = Date.now() + 12 * 60 * 60 * 1000 // 12小时后过期
      localStorage.setItem('isLogin', 'true')
      localStorage.setItem('loginExpire', expireTime)
      this.$router.push('/')
      this.$message.success('登录成功')
    } else {
          this.$message.error('账号或密码错误')
        }
        this.loading = false
      }, 1000)
    }
  }
}
</script>

<style>
/* 添加全局样式，确保字体加载 */
@import url('https://fonts.googleapis.com/css2?family=Microsoft+YaHei&display=swap');

* {
  font-family: 'Microsoft YaHei', sans-serif;
}
</style>

<style scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: url('../assets/bgpc.jpg') no-repeat center center fixed;
  background-size: 100% 100%;  /* 修改这里，强制图片填充满容器 */
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #1e3c72;  /* 添加背景色，防止图片缩放后露出空白 */
}

.login-box {
  width: 400px;
  padding: 40px;
  margin-left: 60%;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.login-box h2 {
  text-align: center;
  color: #2a5298;
  margin-bottom: 30px;
  font-size: 24px;  /* 添加固定字体大小 */
  transition: all 0.3s;  /* 添加平滑过渡效果 */
  white-space: nowrap;  /* 防止文字换行 */
}

.input-group {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
  margin-top: 10px;
}
</style>